// extracted by mini-css-extract-plugin
module.exports = {"input":"styles__input___3g339","inputWrapper":"styles__inputWrapper___1Jd6s","checkLabel":"styles__checkLabel___3_xY2"};